<template>
    <div>
    </div>
</template>
<script>
  export default {
    name: 'AppDashboard'
  }
</script>
